import { FlexFileError } from './FlexFileError';

import {ReportDataService} from '../../report-data.service';

export class LookupError extends FlexFileError {

  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService, description, additionalData) {
    super(reportService, description, 'BAD_DATE_FORMAT', 0, true, additionalData);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/errors/LookupError.ts